// extracted by mini-css-extract-plugin
export var cardStyle = "card-module--cardStyle--4Ptuw";
export var hasPaddingStyle = "card-module--hasPaddingStyle--Cz-IB";
export var hoverStateStyle = "card-module--hoverStateStyle--2Sc4e";
export var isFullWidthStyle = "card-module--isFullWidthStyle---Aija";
export var isRaisedStyle = "card-module--isRaisedStyle--DQey5";
export var overflowHiddenStyle = "card-module--overflowHiddenStyle--FxGXb";
export var stretchStyle = "card-module--stretchStyle--N5sIz";